__turbopack_context__.v({
  "buttonRows": "_5XIJnW_buttonRows",
  "buttonTabs": "_5XIJnW_buttonTabs",
  "dot": "_5XIJnW_dot",
  "dotsContainer": "_5XIJnW_dotsContainer",
  "name": "_5XIJnW_name",
  "profile": "_5XIJnW_profile",
  "quote": "_5XIJnW_quote",
  "reviewItem": "_5XIJnW_reviewItem",
  "reviewsContainer": "_5XIJnW_reviewsContainer",
  "scrollContainer": "_5XIJnW_scrollContainer",
});
